import { ModuleRegistry } from "seneca-common/features/module/registry";

import { markAnswer } from "./logic/answers";
import { generateContent } from "./logic/content";

export const MODULE_TYPE = "hyper-flashcard";

export type TYPE = "hyper-flashcard";

export const register = (moduleRegistry: ModuleRegistry) => {
  return moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .back.staticInformation()
    .displayName("Hyper Flashcard")
    .readOnly()
    .root.register();
};
